import { DocumentCategory, DocumentOwner } from "documents/categories/document-category";
import z from "zod";

const count = z.number().int().nonnegative();

/**
 * The counts the Documents page shows, from `GET documents/counts` (#6710, #6720): each tab's badge,
 * which counts its open rows and does not move with the chips, and each chip's count, which honors the
 * other groups' chips and ignores its own. Counted after the same access filters as the list.
 */
export const DocumentListCountsJSONZ = z.object({
  total: count,
  tabs: z.object({ documents: count, templates: count }),
  categories: z.partialRecord(z.enum(DocumentCategory), count),
  owners: z.partialRecord(z.enum(DocumentOwner), count),
  archived: count,
});

export type DocumentListCounts = z.infer<typeof DocumentListCountsJSONZ>;
